import React from 'react';

import 'styles/common/confirmation-modal.scss';

const DeleteModal = ({ modalTitle, onCancel, onDelete, text1, text2 }) => (
  <div data-bem="DeleteModal">
    <div className="overlay" />
    <div className="confirmation-modal animated zoomIn">
      <div className="modal-body">
        <h2 className="modal-title"> {modalTitle}</h2>
        <div className="modal-content-new">
          <p>{text1} </p>
          <p>{text2}</p>
        </div>
        <div className="modal-footer-new">
          <button className="btn btn-violet-link" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn-violet" onClick={onDelete}>
            Yes Delete
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default DeleteModal;
